import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { InvestorProfile } from '@src/components/sco/InvestorSearch/InvestorProfile';
import { InvestorSearchToolbar } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchToolbar';
import React from 'react';
type InvestorSearchAsideProps = {
  investorProfileId?: string;
};
export const InvestorSearchAside = props => {
  const $ = _c(3);
  if (props.investorProfileId) {
    let t0;
    if ($[0] !== props.investorProfileId) {
      t0 = <VStack bgColor="colorPalette.bg" borderColor="colorPalette.border/50" borderLeft="1px solid" overflowY="auto" width="full"><InvestorSearchToolbar investorProfileId={props.investorProfileId} /><InvestorProfile investorProfileId={props.investorProfileId} /></VStack>;
      $[0] = props.investorProfileId;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  } else {
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
};